export const AUTH_TOKEN_KEY = 'auth_token';
export const TOKEN_CHECK_INTERVAL = 15000;
export const EXPIRED_TOKEN_ERROR = 'TokenExpired';

export const LEGACY_WIDGET_AUTH_METHOD = 'SSO';

export enum AuthMethod {
  SBA = 'SBA',
  WIDGET = 'WIDGET',
  OAUTH = 'OAUTH',
}

export const LSL_CLIENT_ID = 'qantas_hotels_self_service';
export const LSL_AUTH_COOKIE = 'lsl_auth_data';
export const LSL_USER_ID_COOKIE = 'lsl_user_id';
export const LSL_SESSION_COOKIE = 'qh_sess';
